<template>
    <div>
        <kgr-member-classification-data-provider
            v-slot="classificationsScope"
            :member-id="memberId"
            :callback="onClassificationLoaded"
        >
            <kgr-form-scaffold
                :with-primary-buttons="false"
                @backBtnClicked="redirectToOverview"
            >
                <kgr-member-classifications-data-form
                    :classifications="classifications"
                    :club-id="clubId"
                    :member-id="memberId"
                    class="animated fadeIn"
                    :is-deletable="isDeletable"
                    :is-creatable="isCreatable"
                    :is-editable="isEditable"
                    @updated="classificationsScope.reload()"
                />
            </kgr-form-scaffold>
        </kgr-member-classification-data-provider>
    </div>
</template>

<script>
import FormScaffold from '../../components/common/form/FormScaffold';
import MemberClassificationDataProvider from '../../components/data-provider/MemberClassificationDataProvider';
import MemberClassificationsDataForm from '../../components/members/classification/MemberClassificationsDataForm';

export default {
    components: {
        'kgr-member-classifications-data-form':MemberClassificationsDataForm,
        'kgr-member-classification-data-provider': MemberClassificationDataProvider,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
        isCreatable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            classifications: [],
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onClassificationLoaded(classifications) {
            this.classifications = classifications;
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
